import React, { useEffect, useState, useContext, useRef } from 'react';
import styled from 'styled-components/macro';
import NavigatorTree from '../components/Navigator/NavigatorTree';
import EditorContext from '../modules/contexts/editor';
import {
    rebuildNodeMap,
    templateDocs,
    getFigmaTemplates
} from '../modules/libs/lessonLib';
import GlobalContext from '../../modules/contexts/global';

const NavigatorWrapper = styled.div`
    margin-top: 0px;
    overflow-y: auto;
    overflow-x: hidden;
    h2 { padding-top: 30px; text-align: center; }
`;

const LessonNavigatorContainer = ({ setRef }) => {
    const editor = useContext(EditorContext);
    const global = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const loadingTemplates = useRef(false);

    useEffect(() => {
        const loadTemplates = async () => {
            // load template file data (delivered as a gzip JSON file)
            // LessonEditorDev:template/elements: https://www.figma.com/file/MdoUWvA7Prd3yR8uyxaXft/?node-id=678%3A0
            // LessonEditorDev:template/pages: https://www.figma.com/file/MdoUWvA7Prd3yR8uyxaXft/?node-id=679%3A44  <= just this one is needed
            console.log('===> looking to load templates, !templateDocs.templatePages  && !loadingTemplates.current', !templateDocs.templatePages, !loadingTemplates.current);
            if (!templateDocs.templatePages  && !loadingTemplates.current) {
                loadingTemplates.current = true;
                await getFigmaTemplates();
                loadingTemplates.current = false;
            }
        };
        loadTemplates();
    }, []);

    useEffect(() => {
        if (global.currentLessonObject) {
            const [lessons, updatedNodes, droppedNodes] = rebuildNodeMap([global.currentLessonObject], editor.lessonTree);
            if (updatedNodes.size > 0 || droppedNodes.size > 0) {
                editor.updateDBNodeMap([...updatedNodes], [...droppedNodes]);
            }
            editor.lessonTree.children = lessons;
            editor.refreshLessonTree();
        }
    }, [global.currentLessonObject]);

    return (
        <NavigatorWrapper ref={setRef} >
            { loading ? <h2>... Loading ...</h2> : <NavigatorTree root={editor.lessonTree} /> }
        </NavigatorWrapper>
    );
};

export default LessonNavigatorContainer;
